'use strict';

module.exports = 1000;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/var/INTERNAL_MEMOIZE_LIMIT.js
// module id = 285
// module chunks = 0